// angular
//     .module('HeroPRO')
//     .controller('addCALicenseController', addCALicenseController);

import './licenseCA.scss';

/* @ngInject */
export default function AddCALicenseController($scope, LicensesFactory, LicenseTypes, LicenseRejectReasons, moment, LicensesUtilityFactory) {
    const vm = this;
    const minLength = 6;

    vm.valid = false;
    vm.submitted = false;
    vm.businessInfo = {};
    vm.owners = [];
    vm.errorMsg = '';
    vm.showError = false;

    vm.validateLicense = function (contractorId, state) {
        vm.valid = false;

        if (state.LicenseTypes[0].LicenseTypeId !== LicenseTypes.CSLB) {
            return;
        }


        if ($scope.addLicense.licenseNumber && $scope.addLicense.licenseNumber.length < minLength) {
            vm.submitted = true;
            return;
        }

        if (!contractorId) {
            contractorId = $scope.$resolve.contractorId;
        }

        $scope.addLicense.loading = true;
        LicensesFactory.validateLicense($scope.addLicense.licenseNumber, LicenseTypes.CSLB, contractorId).then((response) => {
            vm.submitted = true;
            const data = response.data || response;

            if (LicensesUtilityFactory.licenseExists($scope.addLicense.licenseNumber, $scope.$resolve.licenseList)) {
                vm.showError = true;

                vm.errorMsg = LicensesUtilityFactory.getRegjectionMsg(LicenseRejectReasons.Duplicate.Id, data);
                $scope.addLicense.loading = false;

                return;
            }

            if (data.hasOwnProperty('RejectReason')) {
                vm.showError = true;

                vm.errorMsg = LicensesUtilityFactory.getRegjectionMsg(data.RejectReason, data);
                $scope.addLicense.loading = false;

                return;
            }

            vm.valid = data.hasOwnProperty('Success');

            vm.businessInfo = data.MetaData;

            $scope.addLicense.expiration = moment(vm.businessInfo.ExpireDate).format('MM/DD/YYYY');
            vm.businessInfo.BusinessInfo.Address = LicensesUtilityFactory.getStreetAddress(vm.businessInfo.BusinessInfo);
            vm.businessInfo.BusinessInfo.CityState = LicensesUtilityFactory.getCityState(vm.businessInfo.BusinessInfo);

            if (data.MetaData.hasOwnProperty('OwnerPrincipals')) {
                vm.owners = LicensesUtilityFactory.getOwnerNames(vm.businessInfo.OwnerPrincipals, state.StateGeoId);
            }

            $scope.addLicense.loading = false;
        });
    };

    vm.updateSubmit = function () {
        vm.submitted = false;
        vm.showError = false;
        vm.valid = false;
    };

    vm.resetErrorMsg = function ($event) {
        const element = $event.target;
        if (angular.isDefined(element.value) && element.value !== null && element.value.length > 0) {
            $scope.addLicense.showErrorMsg = false;
        } else {
            $scope.addLicense.showErrorMsg = true;
        }
    };

    $scope.$on('reset', () => {
        vm.updateSubmit();
    });
}



// WEBPACK FOOTER //
// ./src/app/accounts/licenses/addLicense/CA/addCALicenseController.js